module.exports = __webpack_public_path__ + "static/img/credit.32d8309.png";